import { render, staticRenderFns } from "./AccountQuestionsNotification.vue?vue&type=template&id=253adfa6&scoped=true&"
import script from "./AccountQuestionsNotification.vue?vue&type=script&lang=js&"
export * from "./AccountQuestionsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253adfa6",
  null
  
)

export default component.exports